import React, {useContext, useEffect, useMemo, useState} from "react";
import MainHeader from "../component/MainHeader";
import Footer from "./Footer";
import Exchange from "./component/Exchange";
import BG_URL from "src/asset/rebate/bg.jpg";
import GiftGrid from "./component/GiftGrid";
import GiftPaymentForm from "./component/GiftPaymentForm";
import AppQueryClientProvider from "../context/AppQueryClientProvider";
import {Button, message, Modal, Result, Spin} from "antd";
import UserContextProvider from "../component/user/UserContextProvider";
import Explain from "./component/Explain";
import MyCoinAccount from "./component/MyCoinAccount";
import {Layout, LayoutContent, LayoutHeader, Viewer} from "./styles";
import Advert from "./component/Advert";
import UserContext from "../component/user/context/UserContext";
import {useQuery, useQueryClient} from "react-query";
import {http, isErrorException} from "@firefly/fly-http";
import Activation from "./component/Activation";
import {ViewData} from "./typing";


export interface Gift {
    level: string;

}
interface PaymentGift {
    level: number;
}


declare global {
    export interface Window {
        viewData: any;
    }
}
const viewData: ViewData = window.viewData;
const game = viewData.game;
const backgroundImage = viewData.variables.backgroundImage;
const enabledExchange = viewData.variables.enabledExchange;
const activation = viewData.variables.activation;
const rule = viewData.variables.rule;
const levels = viewData.levels;
const advert = viewData.variables.advert;

const isTest = window.location.hash === "#test";
function App() {

    const [selectedGift, setSelectedGift] = useState<PaymentGift | undefined>();

    const {
        current,
        authenticated,
    } = useContext(UserContext);


    const queryClient = useQueryClient();


    const gameId = game.id;
    const {
        isFetching,
        data: vipServers,
        error,
    } = useQuery({
        enabled: !!current?.uid,
        queryKey: ['viewer', current?.uid, 'gamevip', gameId, 'servers'],
        queryFn: () => {
            return http.get(`/api/wangame/viewer/game-vips/${gameId}/servers`)
        },
        meta: {
            onError: () => {
                // message.error("获取游戏币服务器失败")
                return false;
            }
        }
    });

    const [completed, setCompleted] = useState<any | false>(false);


    const isNoGameVip = useMemo(() => {
        if (isErrorException(error)) {
            const {
                error: errorInfo
            } = error;
            return errorInfo.code === 'WANGAME_ERR_NOT_GAME_VIP';
        }
        return undefined;
    }, [error]);

    function requiredActivationHelp() {
        Modal.warn({
            style: {
              top: 260
            },
            content: activation.help
        });
    }

    return <div className={"app"}>
        <MainHeader />
        {!isTest ? <div className={"main-body"} style={{backgroundImage: `url(${backgroundImage})`}}>
            <div className={"main-content"} >
                {advert?.left?.enabled ? <Advert
                    image={{
                        width: 200,
                        height: 220,
                        src: advert.left.image,
                    }}
                    description={advert.left.description}
                    links={advert.left.links}
                /> : null}
                <Viewer>
                    <MyCoinAccount
                        name={game.id}
                        label={game.name}
                    />
                    <Activation
                        enabled={!!(activation?.enabledSelfService && isNoGameVip)}
                        gameId={game.id}
                    />
                </Viewer>
                {enabledExchange ? <Layout>
                    <LayoutHeader>
                        兑换游戏币
                    </LayoutHeader>
                    <LayoutContent style={{minHeight: 180}}>
                        {isFetching ? <Spin /> : <>
                            <Exchange
                                gameId={game.id}
                                vipServers={vipServers}
                                onClick={() => {
                                    if (isNoGameVip) {
                                        requiredActivationHelp();
                                        return false;
                                    }
                                    return true;
                                }}
                            />
                        </>}
                    </LayoutContent>
                </Layout> : null}
                {levels?.length > 0 ? <Layout>
                    <LayoutHeader>
                        充值返利
                    </LayoutHeader>
                    <LayoutContent>
                        <GiftGrid
                            data={levels.map((level) => {
                                return {
                                    level: level,
                                }
                            })}
                            onClick={(gift) => {
                                authenticated().then(() => {
                                    if (isNoGameVip) {
                                        requiredActivationHelp();
                                        return
                                    }
                                    setSelectedGift(gift);
                                }, () => {

                                })

                            }}
                        />
                    </LayoutContent>
                </Layout> : null}

                {rule ? <Explain
                    title={
                        rule.title
                    } description={
                        rule.description
                    }
                /> : null}
                <Modal
                    open={!!selectedGift}
                    footer={null}
                    width={680}
                    destroyOnClose
                    onCancel={() => {
                        setSelectedGift(undefined)
                    }}
                >
                    {selectedGift ? <GiftPaymentForm
                        user={current}
                        gameId={game.id}
                        subject={`充值${selectedGift.level}元100%返利`}
                        extra={`充值后将获得${game.name}平台币`}
                        level={selectedGift.level}
                        onFinish={() => {
                            setSelectedGift(undefined);
                            queryClient.invalidateQueries({
                                queryKey: ['viewer', 'coin-account']
                            }).then();
                            setCompleted(true)
                        }}
                    />: null}
                </Modal>
                <Modal open={completed} footer={null} destroyOnClose>
                    <Result
                        status="success"
                        title="平台币充值成功!"
                        // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
                        extra={[
                            <Button type="primary" onClick={() => {
                                setCompleted(false)
                            }}>
                                关闭
                            </Button>,
                            // <Button key="buy">Buy Again</Button>,
                        ]}
                    />
                </Modal>
            </div>
        </div> : null}
        <Footer />
    </div>
}


export default () => {
    return <AppQueryClientProvider>
        <UserContextProvider>
            <App />
        </UserContextProvider>
    </AppQueryClientProvider>
};